import script from "./Competition.vue?vue&type=script&setup=true&lang=js"
export * from "./Competition.vue?vue&type=script&setup=true&lang=js"

import "@/assets/common.css?vue&type=style&index=0&lang=css&external"
import "./Competition.vue?vue&type=style&index=1&id=379f3691&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-379f3691"]])

export default __exports__